/* eslint-disable no-use-before-define */
import React from 'react'
import { useCalculator, STEPS } from './use-calculator'
import { ChartOrTable } from './calc-output/chart-or-table'
import { YieldTable } from './calc-output/yield-table'
import { PerTransaction } from './calc-output/per-transaction'
import { isEmpty, SectionHeader, SectionBody } from '../twd'
import { ActionCard } from './calc-output/action-card'

export const CalcOutput = () => {
    const {
        step, calcOutput, changeCusip, bondInfo,
    } = useCalculator()
    const [showSection, setShowSection] = React.useState(true)

    const isShow = bondInfo && bondInfo.canCalc
        && !isEmpty(calcOutput)
        && step===STEPS.CALC_OUTPUT
    if (!isShow) return null

    return <React.Fragment>
        <div className="row vertical-offset-xxs">
        <div className={"col-md-12"}>
            <SectionHeader
                title="Calculation results"
                cls="subhead"
                arrowSize='large'
                show={showSection}
                setShow={setShowSection}
            />
        </div>
        </div>

        <SectionBody show={showSection}>
        <div className="row vertical-offset-base">
        <div className="col-md-6 col-xs-12">
            <div style={{padding:'10px', backgroundColor:'#f6f6f6'}}>
            <YieldTable />
            <div className="vertical-offset-sm"></div>
            <PerTransaction />
            </div>
        </div>

        <div className="col-md-6 col-xs-12">
            <div className="md-show vertical-offset-base"></div>
            <ChartOrTable chartData={calcOutput.priceYields} bondInfo={bondInfo}/>
            <div className="vertical-offset-base"></div>
            <ActionCard />
        </div>
        </div>

        <div className="row vertical-offset-base">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-center">
            <button type="button"
                className="btn btn-primary-outline btn-block"
                onClick={changeCusip}
            >
                Change CUSIP
            </button>
        </div>
        <div className="col-md-4"></div>
        </div>
        </SectionBody>
       </React.Fragment>

}